export const TWO_DAYS_LEFT_BANNER_HEADING =
  'Hurry! Save your citations before they expire in 2 days'
export const LAST_DAY_BANNER_HEADING =
  'Hurry! Save your citations before they expire tomorrow'

export const SEVEN_DAYS_LEFT_BANNER_SUB_HEADING =
  'Save your citations by creating an account'
export const LAST_TWO_DAYS_BANNER_SUB_HEADING = 'Create an account to save your citations'

export const getDaysPassed = (projectCreateDate: string) => {
  const past = new Date(projectCreateDate)
  const now = new Date()

  // Calculate the difference in milliseconds
  const differenceInMilliseconds = now.getTime() - past.getTime()

  // Convert milliseconds to days and round down to the nearest whole day
  const days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24))
  return days
}

export const getBannerHeadings = (projectCreateDate: string) => {
  const daysPassed = getDaysPassed(projectCreateDate)
  switch (daysPassed) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
      return {
        bannerHeading: `Your citations will expire in ${7 - daysPassed} days`,
        bannerSubHeading: SEVEN_DAYS_LEFT_BANNER_SUB_HEADING,
      }
    case 5:
      return {
        bannerHeading: TWO_DAYS_LEFT_BANNER_HEADING,
        bannerSubHeading: LAST_TWO_DAYS_BANNER_SUB_HEADING,
      }
    default:
      return {
        bannerHeading: LAST_DAY_BANNER_HEADING,
        bannerSubHeading: LAST_TWO_DAYS_BANNER_SUB_HEADING,
      }
  }
}
